const handleTabsClick = () => {
  const hiddenTabClass = 'home__press-center-items-wrapper--hidden';

  const buttons = document.getElementsByClassName('home__press-center-button');
  const tabs = document.getElementsByClassName('home__press-center-items-wrapper');

  const updateTabs = (buttonIndex) => {
    Array.from(tabs).forEach((tab, tabIndex) => {
      if (buttonIndex === tabIndex) {
        tab.classList.remove(hiddenTabClass);
      } else {
        tab.classList.add(hiddenTabClass);
      }
    });
  };

  Array.from(buttons).forEach((button, index) => {
    button.addEventListener('click', () => updateTabs(index));
  });
};

const handlePlayClick = () => {
  const activePopupClass = 'home__video-popup--active';

  const popup = document.querySelector('.home__video-popup');

  const togglePopup = (isInitial = false) => {
    popup.classList.toggle(activePopupClass);
    document.body.classList.toggle('is-cropped');

    if (isInitial) {
      popup.querySelector('figure').click();
    }

    document
      .querySelector('.home__video-popup-player.is-loaded iframe')
      .contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
  };

  document.querySelector('.home__video-button')?.addEventListener('click', () => togglePopup(true));
  document.querySelector('.home__video-popup-close')?.addEventListener('click', togglePopup);
};

const HomeNewComponent = () => {
  handleTabsClick();
  handlePlayClick();
};

export const HomeNew = () => {
  $(document).ready(() => HomeNewComponent());
};
